export default {"src":"/_next/static/media/cable_tv.b975a5af.svg","height":100,"width":100};